"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWareHouseList = exports.productDetail = exports.productSetList = exports.productList = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 产品列表
exports.productList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/items/getList', params); });
// 套装产品使用列表
exports.productSetList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/items/getSetList', params); });
// 产品详情
exports.productDetail = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/items/detail', params); });
// crystal产品仓库标志
exports.getWareHouseList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/items/getWareHouseList', params); });
